<template>
  <div class="homeHotBox">
    <el-carousel height="500px">
      <el-carousel-item  v-for="(item, idx) in TopNews.slice(0, 5)" :key="idx" >
        <div class="mediaBox">
          <el-image fit="cover" class="newImg" :src="item.PicUrl"><div slot="placeholder" class="image-slot"></div></el-image>
          <div class="media hotAnimate">
            <div class="mediaFigue hotBox">
              <span class="month">{{
                moment(item.PubDate).format("MM-DD")
              }}</span>
              <span>{{ moment(item.PubDate).format("YYYY") }}</span>
            </div>
            <div class="mediaBody">
              <h3>{{ item.Title }}</h3>
              <p>{{ item.Summary }}</p>
              <div>
                <router-link :to="`/newsContent?id=${item.Id}`"
                  ><span class="bigMore">{{lang=="en"?'Learn More':'了解更多'}}</span></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      moment: this.$moment,
      dataList: [
        
      ]
    };
  },
  props: ["TopNews","lang"],
  mounted() {
    // console.log(this.$moment(this.TopNews.PubDate).format('YYYY-MM-DD'))
  },
};
</script>

<style lang="scss">
.homeHotBox {
  width: 500px;
  .el-carousel__indicators--horizontal {
    // left: 750px;
    // transform: translateX(0);
    bottom:220px
  }
  .el-carousel__button {
    // background: #bfbfbf;
  }
  .is-active {
    .el-carousel__button {
      background: #d71820;
    }
  }
  .el-carousel__item {
    background-color: #fff;
  }
}
.mediaBox {
  display: flex;
  flex-direction: column;
  max-width: 500px;
  .newImg {
    width: 500px;
    height: 280px;
    background-color: #f9f9f9;
    margin-bottom: 20px;
  }
  .bigMore {
    border: 1px solid #bfbfbf;
    color: #000;
  }
  .hotBox {
    transition: all 0.5s;
    min-width: 70px;
    span {
      display: block;
      text-align: center;
    }
    .month {
      font-size: 20px;
      padding-bottom: 10px;
    }
  }
  .mediaBody {
    padding-left: 20px;
    width:500px;
    p {
      padding:0 0 0 10px;
      margin:20px 0;
      border-left:1px solid #bfbfbf;
      line-height:21px;
      max-height: 42px;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
    }
  }
  .hotAnimate {
    overflow: hidden;
    transition: all 0.5s;
    &:hover {
      padding-left: 30px;
    }
  }
}
</style>